import React from 'react';
import {StyleSheet, View} from 'react-native';

import {getSkeletonColors, STAGGER} from '../constants';
import {BoneButton} from '../primitives/BoneButton';
import {BoneImage} from '../primitives/BoneImage';
import {BoneText} from '../primitives/BoneText';

/**
 * Skeleton for horizontal search result items.
 * Mirrors: ProductTileHorizontal layout (80px image left, content right)
 * Reference: app/components/ProductTile/variants/ProductTileHorizontal.tsx
 *   styles.container (flexDirection:row, padding:6, minHeight:96)
 *   styles.imageContainer (width:80), styles.contentContainer (flex:1, paddingLeft:10)
 */
export const SearchItemSkeleton: React.FC = React.memo(() => (
  <View style={styles.container}>
    <View style={styles.imageContainer}>
      <BoneImage variant="thumbnail" animationDelay={STAGGER.delay(0)} />
    </View>
    <View style={styles.contentContainer}>
      <BoneText variant="h1" width="85%" animationDelay={STAGGER.delay(1)} />
      <BoneText variant="body" width="50%" animationDelay={STAGGER.delay(2)} />
      <View style={styles.bottomRow}>
        <View style={styles.priceContainer}>
          <BoneText variant="caption" width="60%" animationDelay={STAGGER.delay(3)} />
          <BoneText variant="price" width="55%" animationDelay={STAGGER.delay(4)} />
        </View>
        <View style={styles.actionsContainer}>
          <BoneButton animationDelay={STAGGER.delay(5)} />
        </View>
      </View>
    </View>
  </View>
));

SearchItemSkeleton.displayName = 'SearchItemSkeleton';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: 6,
    minHeight: 96,
    backgroundColor: getSkeletonColors().cardBackground,
    borderWidth: 0.5,
    borderColor: getSkeletonColors().border,
    borderRadius: 4,
  },
  imageContainer: {
    width: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentContainer: {
    flex: 1,
    paddingLeft: 10,
    justifyContent: 'space-between',
  },
  bottomRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  priceContainer: {
    flex: 1,
    gap: 4,
  },
  actionsContainer: {
    justifyContent: 'center',
    width: 110,
  },
});
